import {
  STORE_EXPENSE_DATA_CHANGED_ERROR_CODE,
  STORE_EXPENSE_INVALID_STATUS_ERROR_CODE,
  STORE_EXPENSE_WORKFLOW_ERROR_CODE
} from './store-expense-workflow-error';
import { RefundReasonEnum, StoreExpenseStatusEnum } from './store-expense.enum';

export class StoreExpenseRemainResponse {
  storeNo?: string;
  expenseRemainingAmount: ExpenseAmount;
}

export class ExpenseAmount {
  amount: number;
  currency: string;
}

export class StoreExpenseRequestSearchCriteria {
  searchCriteria?: string;
  createdDateFrom?: string;
  createdDateTo?: string;
  status?: string;
  page: number;
  size: number;
}

export class StoreExpenseRequestListContent {
  storeNo: string;
  version: number;
  docNo: string;
  expenseType: string;
  expenseTypeEn: string;
  status: string;
  totalAmount: ExpenseAmount;
  createdDate: string;
  createdByName: string;
  createdByNameEn: string;
  lastModifiedDate: string;
  lastModifiedByName: string;
  lastModifiedByNameEn: string;
}

export const storeExpenseRequestStatusList = [
  { value: '', label: 'สถานะทั้งหมด' },
  { value: StoreExpenseStatusEnum.AWAITING_EVIDENCE, label: 'รอบันทึกหลักฐาน' },
  { value: StoreExpenseStatusEnum.AWAITING_APPROVAL, label: 'รออนุมัติ' },
  { value: StoreExpenseStatusEnum.APPROVED, label: 'อนุมัติ' },
  { value: StoreExpenseStatusEnum.SENT_BACK, label: 'รอการแก้ไข' },
  { value: StoreExpenseStatusEnum.CANCELLED, label: 'ยกเลิก' }
];

export class StoreExpenseViewResponse {
  id: string;
  version: number;
  docNo: string;
  deviceNo: string;
  storeNo: string;
  storeCode: string;
  storeName: string;
  status: StoreExpenseStatusEnum; // FE should map wording for TH and EN
  saleScheduleDate: string; // Use format 'YYYY-MM-DD'
  expenseType: string; // FE should map wording for TH and EN
  totalAmount: Amount;
  amountFromDrawer: Amount;
  amountFromSafe: Amount;
  shiftDocumentNo: string;
  createdBy: string;
  createdDate: string; // Use ISO 8601 format
  createdByName: string;
  createdByNameEn: string;
  evidenceFilePath: string;
  expenseDetails: string;
  approvalFlowId: string;
  currentApprovals: string[];
  toBeRefundedInfo: ToBeRefundedInfo;
  refundTransferDetails: RefundTransferDetail[];
}

export interface Amount {
  amount: number;
  currency: string;
}

export class SubmitStoreExpenseRequest {
  docNo: string;
  version: number;
  file?: File;
  expenseDetails?: string;
}

export class SubmitStoreExpenseSendBackRequest extends SubmitStoreExpenseRequest {
  bankCode?: string;
  transferAmount?: string;
  transferDateTime?: string;
  transferSlip?: File;
}

export class StoreExpenseCancelRequest {
  version: number;
  action: string;
  docNo: string;
  comment: string;
}

export interface ToBeRefundedInfo {
  amountToBeRefunded: Amount | null;
  expenseAmount: Amount;
  correctAmount: Amount | null;
  reason: RefundReasonEnum;
  comment: string;
}

export interface RefundTransferDetail {
  no: number;
  approvalFlowId: string | null;
  expenseDetails: string | null;
  amountToBeRefunded: Amount | null;
  expenseAmount: Amount;
  correctAmount: Amount | null;
  reason: string;
  comment: string;
  bankCode: string | null;
  bankName: string | null;
  transferAmount: Amount | null;
  transferDateTime: string | null;
  evidenceFilePath: string | null;
  refundTransferFilePath: string | null;
  createdBy: string;
  createdByName: string;
  createdByNameEn: string;
  createdDate: string;
  lastModifiedBy: string;
  lastModifiedByName: string;
  lastModifiedByNameEn: string;
  lastModifiedDate: string;
}

export const StoreExpenseErrorCode: string[] = [
  STORE_EXPENSE_DATA_CHANGED_ERROR_CODE,
  STORE_EXPENSE_INVALID_STATUS_ERROR_CODE,
  STORE_EXPENSE_WORKFLOW_ERROR_CODE
];
